export const gridLabels = {
    weightedAvg: "Weighted average",
}
